const API_URL = process.env.REACT_APP_BACKEND_URL;

export const assessmentAPI = {
  submit: async (data) => {
    const res = await fetch(`${API_URL}/api/assessment/submit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error('Failed to submit assessment');
    return res.json();
  },
  get: async (id) => {
    const res = await fetch(`${API_URL}/api/assessment/${id}`);
    if (!res.ok) throw new Error('Failed to get assessment');
    return res.json();
  }
};

export const leadAPI = {
  create: async (data) => {
    const res = await fetch(`${API_URL}/api/leads`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error('Failed to create lead');
    return res.json();
  },
  list: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const res = await fetch(`${API_URL}/api/leads?${query}`);
    if (!res.ok) throw new Error('Failed to list leads');
    return res.json();
  },
  update: async (id, data) => {
    const res = await fetch(`${API_URL}/api/leads/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error('Failed to update lead');
    return res.json();
  }
};

export const companyAPI = {
  create: async (data) => {
    const res = await fetch(`${API_URL}/api/companies`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error('Failed to create company');
    return res.json();
  },
  list: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const res = await fetch(`${API_URL}/api/companies?${query}`);
    if (!res.ok) throw new Error('Failed to list companies');
    return res.json();
  },
  get: async (id) => {
    const res = await fetch(`${API_URL}/api/companies/${id}`);
    if (!res.ok) throw new Error('Failed to get company');
    return res.json();
  },
  update: async (id, data) => {
    const res = await fetch(`${API_URL}/api/companies/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error('Failed to update company');
    return res.json();
  },
  delete: async (id) => {
    const res = await fetch(`${API_URL}/api/companies/${id}`, { method: 'DELETE' });
    if (!res.ok) throw new Error('Failed to delete company');
    return res.json();
  }
};

export const kpiAPI = {
  create: async (data) => {
    const res = await fetch(`${API_URL}/api/kpi-snapshots`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error('Failed to create KPI snapshot');
    return res.json();
  },
  getByCompany: async (companyId) => {
    const res = await fetch(`${API_URL}/api/kpi-snapshots/company/${companyId}`);
    if (!res.ok) throw new Error('Failed to get KPIs');
    return res.json();
  }
};

export const resourceAPI = {
  create: async (data) => {
    const res = await fetch(`${API_URL}/api/resources`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error('Failed to create resource');
    return res.json();
  },
  list: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const res = await fetch(`${API_URL}/api/resources?${query}`);
    if (!res.ok) throw new Error('Failed to list resources');
    return res.json();
  },
  get: async (id) => {
    const res = await fetch(`${API_URL}/api/resources/${id}`);
    if (!res.ok) throw new Error('Failed to get resource');
    return res.json();
  },
  update: async (id, data) => {
    const res = await fetch(`${API_URL}/api/resources/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error('Failed to update resource');
    return res.json();
  },
  delete: async (id) => {
    const res = await fetch(`${API_URL}/api/resources/${id}`, { method: 'DELETE' });
    if (!res.ok) throw new Error('Failed to delete resource');
    return res.json();
  }
};